import React from "react";
import { Icon, Menu } from "semantic-ui-react";

import { commands$ } from "./CommandsStream";

import { usePlaybackState } from "./Sequencer";

export function PlaybackButtons() {
  const playbackState = usePlaybackState();

  const playColor = playbackState !== "idle" ? "red" : undefined;
  const playIcon = playbackState === "playing" ? "pause" : "play";

  const playAction =
    playbackState === "idle" || playbackState === "paused"
      ? () => commands$.play()
      : () => commands$.pause();

  return (
    <>
      <Menu.Item name="step backward" onClick={() => commands$.playPrevious()}>
        <Icon name="step backward" />
      </Menu.Item>
      <Menu.Item id="play-button" name="play" onClick={playAction}>
        <Icon name={playIcon} color={playColor} />
      </Menu.Item>
      <Menu.Item name="stop" onClick={() => commands$.stop()}>
        <Icon name="stop" />
      </Menu.Item>
      <Menu.Item name="step forward" onClick={() => commands$.playNext()}>
        <Icon name="step forward" />
      </Menu.Item>
    </>
  );
}
